import { createTracker } from 'usage-tracker-public';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient'; // @ts-expect-error untyped dependency

import { getParsedTrackingParams } from 'ecosystem-marketplace-core/utils/trackingParams';
import events from '../../events.yaml';
let userEmailPromise;

function maybeGetUserEmail() {
  if (!userEmailPromise) {
    const response = noAuthApiClient.get('/login-verify/echo/user');
    userEmailPromise = response.then(user => user.email);
  }

  return userEmailPromise;
}

const getSessionUrlParams = () => {
  const trackingParams = getParsedTrackingParams();
  return Object.keys(trackingParams).reduce((final, key) => {
    const value = trackingParams[key];
    final.push(`${key}=${value}`);
    return final;
  }, []);
};

export default createTracker({
  events,
  properties: {
    namespace: 'marketplace-unified',
    inAppOrPublic: 'public',
    sessionUrlParams: getSessionUrlParams(),
    email: () => maybeGetUserEmail().catch(() => null)
  },
  isBeforeUnload: true,
  lastKnownEventProperties: ['screen']
});